import { useRef } from 'react';
import Tooltip from './tooltip';

const PlansDescriptor = ({
  hoveredFeatureIndex,
  setHoveredFeatureIndex,
  features,
  setComparisonTableVisible
}) => {
  const wrapperEl = useRef(null);

  const handleFeatureHover = (e) => {
    const element = e.target.closest('.feature-label');
    const index = [...wrapperEl.current.children].indexOf(element);
    setHoveredFeatureIndex(index);
  };

  return (
    <div className='plans-descriptor' ref={wrapperEl}>
      {features.map((feature, index) => (
        <div
          className={classNames('feature-label', {
            hovered: hoveredFeatureIndex == index,
          })}
          key={feature.name}
          onMouseEnter={handleFeatureHover}
        >
          <div className='name'>{feature.name}</div>
          {feature.hint && (
            <div className='hint'>
              <div className='value'>
                <Tooltip content={feature.hint} placement='left'>
                  <i className='fal fa-question-circle'></i>
                </Tooltip>
              </div>
            </div>
          )}
        </div>
      ))}
      <a
        href='#'
        className='feature-label'
        onClick={(e) => {
          e.preventDefault();
          setComparisonTableVisible();
        }}
      >
        <div className='name'>{I18n.t('pricing.plans-comparison')}</div>
        <div className='hint'>
          <div className='value'>
            <i className='fal fa-table'></i>
          </div>
        </div>
      </a>
    </div>
  );
};

export default PlansDescriptor;
